/**
 * Deliciosso Forest Animations
 * Subtle organic ambient effects (no circular patterns)
 * The hero background waves are handled by CSS (.hero-brand::before and ::after)
 */
(function () {
  const supportsMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches === false;

  if (!supportsMotion) return;

  // Add subtle ambient glow effect for sections (not fixed overlay)
  const style = document.createElement("style");
  style.textContent = `
    /* Subtle ambient shimmer for interactive sections */
    .hero-brand__container,
    .featured-products__grid {
      transition: opacity 0.3s ease;
    }
  `;
  document.head.appendChild(style);
})();

// Countdown timers for coming-soon cards
(function () {
  const targets = document.querySelectorAll("[data-countdown-target]");
  if (!targets.length) return;

  const format = (value) => (value < 10 ? `0${value}` : `${value}`);

  const tick = () => {
    const now = new Date().getTime();
    targets.forEach((card) => {
      const target = new Date(card.dataset.countdownTarget).getTime();
      const diff = target - now;
      const display = card.querySelector("[data-countdown-display]");

      if (!display) return;

      if (diff <= 0) {
        display.innerHTML = `<span class="part"><strong>00</strong><small>Disponible</small></span>`;
        const badge = card.querySelector(".countdown-badge");
        if (badge) badge.textContent = "Disponible ahora";
        card.removeAttribute("data-countdown-target");
        return;
      }

      const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
      const days = Math.floor((diff % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const setText = (selector, value) => {
        const el = display.querySelector(selector);
        if (el) el.textContent = format(value);
      };

      setText("[data-countdown-months]", months);
      setText("[data-countdown-days]", days);
      setText("[data-countdown-hours]", hours);
      setText("[data-countdown-minutes]", minutes);
      setText("[data-countdown-seconds]", seconds);
    });
  };

  tick();
  setInterval(tick, 1000);
})();

// Soft cloud ambient background
(function () {
  // Opt-in only. Decorative coffee rain is currently disabled site-wide.
  if (!document.body || !document.body.hasAttribute("data-coffee-ambient")) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isMobileViewport = window.matchMedia("(max-width: 820px)").matches;
  const isCoarsePointer = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
  if (prefersReduced || isMobileViewport || isCoarsePointer) return;

  const body = document.body;
  if (!body) return;

  const allowAmbient =
    body.classList.contains("template-index") ||
    body.classList.contains("page-handle-about") ||
    body.classList.contains("page-handle-nosotros");

  if (!allowAmbient) return;

  if (document.querySelector(".coffee-ambient")) return;

  const cloudCount = Math.max(8, Math.min(14, Math.round(window.innerWidth / 170)));

  const layer = document.createElement("div");
  layer.className = "coffee-ambient";

  const rand = (min, max) => Math.random() * (max - min) + min;

  for (let i = 0; i < cloudCount; i++) {
    const cloud = document.createElement("span");
    cloud.className = "coffee-ambient__bean";

    const width = rand(70, 136);
    const height = width * rand(0.4, 0.52);
    const travel = rand(112, 148);
    const bob = rand(6, 16);
    const startY = rand(4, 72);
    const duration = rand(34, 52);

    cloud.style.left = `${rand(-24, 78)}%`;
    cloud.style.top = `${startY}%`;
    cloud.style.setProperty("--cloud-width", `${width}px`);
    cloud.style.setProperty("--cloud-height", `${height}px`);
    cloud.style.setProperty("--cloud-travel", `${travel.toFixed(2)}vw`);
    cloud.style.setProperty("--cloud-bob", `${bob.toFixed(2)}px`);
    cloud.style.opacity = `${rand(0.24, 0.44).toFixed(2)}`;
    cloud.style.setProperty("--bean-duration", `${duration.toFixed(2)}s`);
    cloud.style.setProperty("--bean-rotate-start", `${rand(-2, -0.4).toFixed(2)}deg`);
    cloud.style.setProperty("--bean-rotate-mid", `${rand(0.2, 2).toFixed(2)}deg`);
    cloud.style.setProperty("--bean-rotate-end", `${rand(-1.5, 0.8).toFixed(2)}deg`);
    cloud.style.animationDelay = `${rand(0, 24).toFixed(2)}s`;

    layer.appendChild(cloud);
  }

  document.body.appendChild(layer);
})();

// About section fast-scroll reveal guard
(function () {
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  function forceVisibleInView(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const forests = scope.querySelectorAll("[data-about-forest]");
    if (!forests.length) return;

    const viewportH = window.innerHeight || 0;

    forests.forEach((forest) => {
      const revealables = forest.querySelectorAll("[data-forest-reveal]");
      revealables.forEach((el) => {
        if (el.classList.contains("is-visible")) return;
        const rect = el.getBoundingClientRect();
        const aboveFold = rect.top <= viewportH * 0.92;
        const alreadyPassed = rect.bottom <= viewportH * 0.2;
        if (aboveFold || alreadyPassed) {
          el.style.setProperty("--forest-delay", "0ms");
          el.classList.add("is-visible");
        }
      });
    });
  }

  let ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      forceVisibleInView(document);
    });
  }

  function init(root) {
    forceVisibleInView(root || document);
    window.setTimeout(() => forceVisibleInView(root || document), 180);
    window.setTimeout(() => forceVisibleInView(root || document), 700);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize, { passive: true });

  document.addEventListener("shopify:section:load", (event) => {
    init(event && event.target ? event.target : document);
  });
})();
